var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputValidator',{class:_vm.$style.rowSpacing,attrs:{"config":{
    attribute: 'email',
    label: 'Distribution Group Email',
    name: 'email',
    validate: 'email',
    value: _vm.email,
  },"tooltip":_vm.tooltip},on:{"InputValidatorModel":_vm.handleManagementGroupInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }